module.exports = __webpack_public_path__ + "svg/payment-way1.svg?7ea938174301ef61c7cde4f28d8449aa";